import React from 'react'
import { Breadcrumb } from 'antd'
import { Link } from 'react-router-dom'
import { LayoutCMS } from 'components'
import TableNewsCrawler from './libraries'

export const PageNewsCrawlerComponent = (props: any) => {
  const title = 'News Crawler'
  const layoutCMSProps = {
    breadcrumb: (
      <>
        <Breadcrumb.Item>
          <Link to="/article/news-crawler">News Crawler</Link>
        </Breadcrumb.Item>
      </>
    ),
    documentTitle: title,
    history: props.history,
    pageTitle: title,
  }

  return (
    <LayoutCMS {...layoutCMSProps}>
      <TableNewsCrawler />
    </LayoutCMS>
  )
}



// WEBPACK FOOTER //
// ./src/pages/news-crawler/component.tsx